// ------------------------------------------------------------------
// EDIT ME: central place for brand info so you don't hunt through
// components. Most "quick edits" for this template start here.
// ------------------------------------------------------------------
const siteConfig = {
  brandName: "WinRevo",
  tagline: " WINREVO membantu bisnis dan industri menggunakan teknologi — AI, IoT, software, energy, automation, hingga robotics — untuk bekerja lebih cepat, lebih efisien, dan lebih menguntungkan.",
  socials: [
    { name: "Instagram", url: "https://instagram.com" },
  ],
  footerColumns: [
    {
      title: "NAVIGATION",
      links: [
        { label: "Cara Kerja", href: "#features" },
        { label: "Business Unit", href: "#business" },
        { label: "Perjalanan", href: "#journey" },
      ],
    },
    {
      title: "COMPANY",
      links: [
        { label: "Tentang", href: "#about" },
        { label: "Kontak Kami", href: "#cta" },
      ],
    },
    {
      title: "Legal",
      links: [
        { label: "Privacy Policy", href: "#" },
        { label: "Terms of Service", href: "#" },
      ],
    },
  ],
};

export default siteConfig;
